import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { BillManagementList } from '@/components/pages/Admin/BillManagement/List'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/bill/')({
  component: BillPage,
})

function BillPage() {
  const t = useTranslations('admin.bill_management')

  return (
    <HomeContentContainer title={t('title')}>
      <BillManagementList />
    </HomeContentContainer>
  )
}

